// extracted by mini-css-extract-plugin
export default {"blocks":"ProductKindHeader-blocks__QJE0","root":"ProductKindHeader-root_KlSv7"};